import { dcAuthApi } from './apiBase';

export type UserBrief = {
  id: string;
  username: string;
  email: string;
  name: string;
  displayName?: string | null;
};

type UsersPageDto = {
  count: number;
  data: UserBrief[];
  limit: number;
  page: number;
};

export async function searchUsers(search: string): Promise<UserBrief[]> {
  const q = new URLSearchParams({
    search,
    page: '1',
    page_size: '20',
  });
  const res = await dcAuthApi.get<UsersPageDto>(`/users?${q.toString()}`);
  return res.data.data ?? [];
}

export async function getUser(userId: string): Promise<UserBrief | null> {
  try {
    const res = await dcAuthApi.get<UserBrief>(`/users/${encodeURIComponent(userId)}`);
    return res.data;
  } catch {
    return null;
  }
}
